import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Home from './pages/Home';
import CV from './pages/CV';
import Assignments from './pages/Assignments';
import Towns from './pages/Towns';
import Profile from './pages/Profile';
import Login from './pages/Login';
// Navigation component
function Navigation() {
    const location = useLocation();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    useEffect(() => {
        // Check if user is logged in (simple check for now)
        const token = localStorage.getItem('ubuntu_token');
        setIsLoggedIn(!!token);
    }, [location]);
    if (!isLoggedIn)
        return null;
    const navItems = [
        { path: '/', icon: '🏠', label: 'Home' },
        { path: '/cv', icon: '📄', label: 'CV' },
        { path: '/assignments', icon: '📋', label: 'Work' },
        { path: '/towns', icon: '🏘️', label: 'Towns' },
        { path: '/profile', icon: '👤', label: 'Profile' },
    ];
    return (_jsx("nav", { className: "fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-bottom z-50", children: _jsx("div", { className: "flex justify-around items-center py-2", children: navItems.map((item) => (_jsxs("a", { href: item.path, className: `flex flex-col items-center py-1 px-3 rounded-lg transition-colors ${location.pathname === item.path
                    ? 'text-ubuntu-green'
                    : 'text-gray-500'}`, children: [_jsx("span", { className: "text-xl mb-0.5", children: item.icon }), _jsx("span", { className: "text-[10px] font-medium", children: item.label })] }, item.path))) }) }));
}
// App component
export default function App() {
    return (_jsx(BrowserRouter, { children: _jsxs("div", { className: "min-h-screen pb-20", children: [_jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(Login, {}) }), _jsx(Route, { path: "/", element: _jsx(Home, {}) }), _jsx(Route, { path: "/cv", element: _jsx(CV, {}) }), _jsx(Route, { path: "/assignments", element: _jsx(Assignments, {}) }), _jsx(Route, { path: "/towns", element: _jsx(Towns, {}) }), _jsx(Route, { path: "/profile", element: _jsx(Profile, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }), _jsx(Navigation, {})] }) }));
}
//# sourceMappingURL=App.js.map